import { getURLParameter } from './utilities.js';
import 'jquery-ui/ui/widgets/slider';
import 'jquery-ui/themes/base/slider.css';
import '../../themes/categories.css'
import './jquery.ui.touch-punch.min.js';

/* ---------------------------------------------------------------------------
 * URL da listagem — parser e montador
 *
 * Estrutura canonica:
 *
 *   /<categoria>[/<subcategoria>]/[f/<slug>/...][s/<slug>/...][pagina-N/][?query]
 *
 * REGRA: a query string e SEMPRE o ultimo componente da URL. Nada de path
 * depois do "?". Foi exatamente isso que gerou o 500 de 28/07/2026:
 *
 *   /vinho/?ordem=menor-preco&price=0-199/f/espanha/
 *
 * O codigo antigo montava a URL por indice fixo (urlArr[4]), assumindo que a
 * posicao 4 era a subcategoria. Sem subcategoria e com query string, o indice 4
 * cai na propria query, que entao era concatenada como se fosse pasta. O price
 * chegava no PHP como "0-199/f/espanha/", o range nao fazia parse, o WHERE saia
 * vazio e o SQL quebrava em Dao.php:73.
 *
 * Aqui o path e a query sao tratados separadamente, sempre, por todos os
 * handlers. Nao ha indice fixo.
 * ------------------------------------------------------------------------ */

/**
 * Decompoe a URL atual em: categoria/subcategoria (base), filtros, skus e query.
 * Ignora a paginacao de proposito — mudar filtro deve voltar para a pagina 1.
 */
function lerUrl() {
	const u = new URL(window.location.href);
	const segmentos = u.pathname.split('/').filter(Boolean);

	const base = [];
	const filtros = [];
	const skus = [];
	let modo = 'base';

	segmentos.forEach(function (seg) {
		if (seg === 'f') { modo = 'f'; return; }
		if (seg === 's') { modo = 's'; return; }
		if (/^pagina-\d+$/.test(seg)) { modo = 'pagina'; return; }

		if (modo === 'base')      base.push(seg);
		else if (modo === 'f')    filtros.push(seg);
		else if (modo === 's')    skus.push(seg);
		// modo === 'pagina': descarta o resto
	});

	return { url: u, base: base, filtros: filtros, skus: skus, query: u.searchParams };
}

/**
 * Remonta a URL na ordem canonica. A query string entra por ultimo, sempre.
 *
 * @param {object} p     retorno de lerUrl(), possivelmente modificado
 * @param {URLSearchParams} [query] sobrescreve p.query se informado
 */
function montarUrl(p, query) {
	if (p.base.length === 0) return '/';

	let path = '/' + p.base.join('/') + '/';
	if (p.filtros.length) path += 'f/' + p.filtros.join('/') + '/';
	if (p.skus.length)    path += 's/' + p.skus.join('/') + '/';

	const qs = (query || p.query).toString();
	return path + (qs ? '?' + qs : '');
}

/**
 * Slug do <li>, ignorando classes de estado adicionadas pelo proprio script.
 * Evita depender da ordem entre removeClass('active') e attr('class').
 */
function slugDoItem($li) {
	return ($li.attr('class') || '')
		.split(/\s+/)
		.filter(function (c) { return c && c !== 'active'; })[0];
}

/** Marca o <li> como ativo e abre o accordion que o contem. */
function ativarItem($li) {
	$li.addClass('active');
	$li.parent().removeClass('collapse').addClass('collapse show');
	$li.parent().parent().find('a').removeClass('collapsed');
}

jQuery(function () {

	const atual = lerUrl();

	const searchLocation = atual.query.get('searchLocation');
	const c = atual.query.get('c');

	/* --- marca categoria ativa ------------------------------------------ */

	$('div.categories ul li').each(function () {
		const slug = slugDoItem($(this));
		if (!slug) return;

		// atual.base contem apenas segmentos de path — imune a query string
		if (atual.base.indexOf(slug) !== -1 || slug === searchLocation || slug === c) {
			ativarItem($('div.categories ul li.' + slug));
		}
	});

	/* --- marca marca (manufacturer) ativa -------------------------------- */

	const manufacturers = atual.query.get('m');
	if (manufacturers) {
		$('div.manufacturers ul li').each(function () {
			const slug = slugDoItem($(this));
			if (slug && slug.indexOf(manufacturers) !== -1) {
				ativarItem($('div.manufacturers ul li.' + slug));
			}
		});
	}

	/* --- marca filtros ativos -------------------------------------------- */

	if (atual.filtros.length) {
		$('div.filters ul li').each(function () {
			const slug = slugDoItem($(this));
			if (slug && atual.filtros.indexOf(slug) !== -1) {
				ativarItem($('div.filters ul li.' + slug));
			}
		});
	}

	/* --- marca skus ativos ------------------------------------------------ */

	if (atual.skus.length) {
		$('div.skus ul li').each(function () {
			const slug = slugDoItem($(this));
			if (slug && atual.skus.indexOf(slug) !== -1) {
				ativarItem($('div.skus ul li.' + slug));
			}
		});
	}

	/* --- clique em filtro -------------------------------------------------
	 * Toggle derivado do PATH, nao da classe .active do DOM: a URL e a fonte
	 * da verdade. A query string atual e preservada integralmente.
	 * -------------------------------------------------------------------- */

	$('div.filters ul li a').on('click', function (e) {
		e.preventDefault();

		const slug = slugDoItem($(this).parent());
		if (!slug) return;

		const p = lerUrl();
		const i = p.filtros.indexOf(slug);
		if (i === -1) p.filtros.push(slug); else p.filtros.splice(i, 1);

		window.location.href = montarUrl(p);
	});

	/* --- clique em sku ---------------------------------------------------- */

	$('div.skus ul li a').on('click', function (e) {
		e.preventDefault();

		const slug = slugDoItem($(this).parent());
		if (!slug) return;

		const p = lerUrl();
		const i = p.skus.indexOf(slug);
		if (i === -1) p.skus.push(slug); else p.skus.splice(i, 1);

		window.location.href = montarUrl(p);
	});

	/* --- clique em marca --------------------------------------------------
	 * O href do link traz os parametros da marca. Fazemos merge na query
	 * atual em vez de substitui-la, para nao perder ordem/price.
	 * -------------------------------------------------------------------- */

	$('div.manufacturers ul li a').on('click', function (e) {
		e.preventDefault();

		const p = lerUrl();
		const href = new URL($(this).attr('href'), window.location.origin);

		const query = new URLSearchParams(p.query.toString());
		href.searchParams.forEach(function (valor, chave) {
			query.set(chave, valor);
		});

		window.location.href = montarUrl(p, query);
	});

	/* --- clique em faixa de preco ----------------------------------------
	 * Toggle: clicar na faixa ja selecionada remove o price da URL.
	 * O estado vem da query string, nao da classe .active — mesma regra dos
	 * filtros, pra nao depender do DOM estar sincronizado com a URL.
	 * set()/delete() cobrem adicionar, trocar e remover sem regex sobre a URL
	 * crua, que era o outro ponto fragil do codigo antigo.
	 * -------------------------------------------------------------------- */

	$('.price-filter li').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		const dataPrice = $(this).attr('data-price');
		if (!/^\d+-\d+$/.test(dataPrice)) return; // ignora data-price malformado

		const p = lerUrl();
		const query = new URLSearchParams(p.query.toString());

		if (query.get('price') === dataPrice) {
			query.delete('price');   // desmarca a faixa
		} else {
			query.set('price', dataPrice);
		}

		window.location.href = montarUrl(p, query);
	});

	/* --- marca a faixa de preco ativa ------------------------------------- */

	const priceAtual = atual.query.get('price');
	if (priceAtual && /^\d+-\d+$/.test(priceAtual)) {
		const $faixa = $('.price-filter li[data-price="' + priceAtual + '"]');
		$faixa.addClass('active');

		// "Compre por preco" e um <details>, nao o accordion de ul.show/collapse:
		// abre por atributo, nao por classe. Com price na URL o filtro ja esta
		// aplicado, entao a secao tem que vir aberta — senao o usuario ve a
		// listagem filtrada sem enxergar qual faixa esta selecionada.
		$faixa.closest('details').attr('open', true);
	}

	/* --- UI: accordions, ver mais/menos, dropdown ------------------------- */

	if ($('ul.show').length === 0) { // abre o primeiro menu se nenhum estiver aberto
		$($('.category-sub-menu ul').get(0)).addClass('collapse show');
		$($('.category-sub-menu h4 a').get(0)).removeClass('collapsed');
	}

	$('.category-filters-lateral h4').on('click', function (e) {
		e.preventDefault();

		const menuClicked = $(this);
		const isActive = menuClicked.children().hasClass('collapsed');

		if (isActive) {
			menuClicked.children().removeClass('collapsed');
			menuClicked.siblings('ul').addClass('show');
		} else {
			menuClicked.children().addClass('collapsed');
			menuClicked.siblings('ul').removeClass('show');
		}
	});

	const itensFilter = $('.ul-marcas').children();
	const seeMore = $('.see-more');

	itensFilter.hide();
	itensFilter.slice(0, 12).show();
	seeMore.show();

	$('.see-more button.ver-menos').hide();

	$('.see-more button.ver-mais').on('click', function () {
		itensFilter.show();
		seeMore.show();
		$(this).hide();
		$('.see-more button.ver-menos').show();
	});

	$('.see-more button.ver-menos').on('click', function () {
		itensFilter.hide();
		itensFilter.slice(0, 12).show();
		seeMore.show();
		$(this).hide();
		$('.see-more button.ver-mais').show();
	});

	$(document).click(function (event) {
		if (!$(event.target).closest('#dropdownMenuLink, .dropdown-categories').length) {
			$('.dropdown-categories').removeClass('active');
		}
	});

	$('#dropdownMenuLink').on('click', function () {
		$('.dropdown-categories').toggleClass('active');
	});

});